const base64Cache: Record<string, string> = {};

export const loadFontBase = async (
  fontName: string,
  fontUrl: string,
  callback?: () => void
): Promise<string | undefined> => {
  if (localStorage.getItem(`font-${fontName}`)) {
    base64Cache[fontName] = localStorage.getItem(`font-${fontName}`)!; // Cache it in memory for faster access
    if (callback) callback();
    return base64Cache[fontName];
  }

  if (base64Cache[fontName]) {
    console.log(`${fontName} base64 is available in memory`);
    if (callback) callback();
    return base64Cache[fontName];
  }

  try {
    const response = await fetch(fontUrl);
    const fontData = await response.arrayBuffer();
    const uint8Array = new Uint8Array(fontData);
    let base64String = '';
    for (let i = 0; i < uint8Array.length; i += 1024) {
      base64String += String.fromCharCode(...uint8Array.slice(i, i + 1024));
    }

    const base64Font = btoa(base64String);

    base64Cache[fontName] = base64Font;
    console.log(`${fontName} font downloaded and encoded to base64`);

    localStorage.setItem(`font-${fontName}`, base64Font);

    if (callback) callback();
    return base64Font;
  } catch (error) {
    console.error(`Failed to load ${fontName} font: ${error}`);
    return undefined;
  }
};
